var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie-chart 1",
    clipPath: "url(#clip0_701_4480)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.25001 9.24677V1.12501C8.25001 0.918012 8.082 0.75 7.875 0.75C3.5325 0.75 0 4.61926 0 9.37499C0 14.1307 3.86926 18 8.62499 18C10.7527 18 11.904 17.6145 13.3635 16.4145C13.5203 16.2855 13.5457 16.0552 13.4213 15.8947L8.25001 9.24677ZM8.62499 17.25C4.28249 17.25 0.749988 13.7175 0.749988 9.37502C0.749988 5.17202 3.74474 1.72727 7.49999 1.51054V9.37502C7.49999 9.45827 7.52773 9.53927 7.57948 9.60526L12.6015 16.062C11.4172 16.9665 10.4295 17.25 8.62499 17.25Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M9.37501 9H17.625C17.832 9 18 8.83199 18 8.62499C18 3.86926 14.1307 0 9.37501 0C9.16801 0 9 0.168012 9 0.375012V8.62502C9 8.83199 9.16801 9 9.37501 9ZM9.74999 0.758988C13.7948 0.9495 17.0505 4.20525 17.241 8.24998H9.74999V0.758988Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M17.6249 9.75H10.1249C9.98093 9.75 9.84818 9.83325 9.78592 9.96375C9.72366 10.0942 9.74243 10.2488 9.83317 10.3605L14.7082 16.3957C14.7734 16.4775 14.8694 16.527 14.9737 16.5345C14.9827 16.5352 14.9909 16.5352 14.9999 16.5352C15.0944 16.5352 15.186 16.4992 15.2557 16.4347C16.9994 14.808 17.9999 12.5085 17.9999 10.125C17.9999 9.91801 17.8319 9.75 17.6249 9.75ZM15.0322 15.603L10.9102 10.5H17.2409C17.1487 12.4065 16.3597 14.2297 15.0322 15.603Z",
    fill: "currentColor"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_701_4480"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie_chart.fb10ce4498d894f4f99b99ea221e13fd.svg";
export { ForwardRef as ReactComponent };